import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  attendance: [],
  currentAttendance: null,
  loading: false,
  error: null,
  statistics: {
    present: 0,
    absent: 0,
    late: 0,
    excused: 0
  },
  filters: {
    date: null,
    group: 'all',
    student: 'all'
  }
}

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setAttendance: (state, action) => {
      state.attendance = action.payload
    },
    setCurrentAttendance: (state, action) => {
      state.currentAttendance = action.payload
    },
    addAttendance: (state, action) => {
      state.attendance.push(action.payload)
    },
    updateAttendance: (state, action) => {
      const index = state.attendance.findIndex(record => record.id === action.payload.id)
      if (index !== -1) {
        state.attendance[index] = action.payload
      }
    },
    setStatistics: (state, action) => {
      state.statistics = action.payload
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    clearError: (state) => {
      state.error = null
    }
  }
})

export const {
  setLoading,
  setError,
  setAttendance,
  setCurrentAttendance,
  addAttendance,
  updateAttendance,
  setStatistics,
  setFilters,
  clearError
} = attendanceSlice.actions

export default attendanceSlice.reducer